import { type AlgoliaProxyRecord } from '../../../algolia'
import { TENANT } from '../../../tenant'

type ProductSearchAlgoliaAccessorIsRxChProps = {
  algoliaRecord: AlgoliaProxyRecord
  tenant: TENANT
}

/*
  Use the algolia recrod prescriptionMedicine flag and tenant to determine if the product is RxCH
*/
export const productSearchAlgoliaAccessorIsRxCh = ({
  algoliaRecord,
  tenant,
}: ProductSearchAlgoliaAccessorIsRxChProps): boolean => {
  return algoliaRecord.prescriptionMedicine && tenant === TENANT.CH
}
